import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"save\"><path d=\"M10 0H2v.01C.89.04 0 .94 0 2.06v7.9c0 1.13.92 2.05 2.05 2.05h7.9c1.13 0 2.05-.92 2.05-2.05V2zM3.5 1.5h5v3h-5zm4 9h-3v-2h3zm3-.55c0 .3-.25.55-.55.55H9V7H3v3.5h-.95c-.3 0-.55-.25-.55-.55v-7.9c0-.29.22-.51.5-.54V6h8V2.12l.5.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol